















import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfileButton from '@/pages/profile/profilemenu/components/button';
// import { ProfileIconPMentoring } from '@/pages/profile/profilemenu/components/icons';

@Component({
  components: {
    ProfileButton,
    // ProfileIconPMentoring,
  },
})
export default class Header extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly noborder!: boolean;

  click(): void {
    this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/news/NewsCard.vue